import { isAssignableUserRole } from './user-access-helper';


export const buildUserCreateUpdateInput = ({
    user,
    values,
    radioValue,
    canCreateUsers = false,
    canAssignUserGroups = false,
    canManageUserGroups = false,
    roles = [],
}) => {
    if (!user?.id && !canCreateUsers) return null;

    const input = {
        id: user?.id ? +user.id : undefined,
        ...values,
        subcontractor_id: radioValue === 'subcontractor'
            ? (values.subcontractor_id?.value || values.subcontractor_id)
            : undefined,
    };

    if (user?.id && !canManageUserGroups && !canAssignUserGroups) {
        delete input.role_id;
    } else if (!canManageUserGroups) {
        if (user?.id && (input.role_id === undefined || String(input.role_id) === String(user.role_id))) {
            delete input.role_id;
        } else {
            const selectedRole = input.role_id != null && input.role_id !== ''
                ? roles.find(role => role?.id != null && String(role.id) === String(input.role_id))
                : undefined;

            if (!isAssignableUserRole(selectedRole)) return null;
        }
    }

    return input;
};
